import { FC } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { Simplify } from '../../../prismicio-types';

import styles from './termsServiceHeroInner.module.scss';

type Variant = 'page' | 'modal';

const titleComponents = (variant: Variant): JSXMapSerializer => ({
  heading1: ({ children }) => (
    <h1 className={`${styles.title} ${styles[variant]}`}>{children}</h1>
  ),
});

const descriptionComponents = (variant: Variant): JSXMapSerializer => ({
  paragraph: ({ children }) => (
    <p className={`${styles.descriptionText} ${styles[variant]}`}>{children}</p>
  ),
});

type Props = {
  data: Simplify<Content.TermsServiceHeroSliceDefaultPrimary>;
  variant?: Variant;
};

export const TermsServiceHeroInner: FC<Props> = ({
  data,
  variant = 'page',
}) => {
  return (
    <>
      <div className={styles.lastUpdate}>
        <p className={styles.lastUpdateText}>{data.last_update_text}</p>
        <p className={styles.lastUpdateValue}>{data.last_update_value}</p>
      </div>
      <PrismicRichText
        field={data.title}
        components={titleComponents(variant)}
      />
      <div className={styles.descriptionWrapper}>
        <PrismicRichText
          field={data.description}
          components={descriptionComponents(variant)}
        />
      </div>
    </>
  );
};
